import TokensModel from './tokensModel';
const tokensElementId = "oauthTokens";

export default (flex = window.flex) => {

    const { safeJSONParse, lzDecompress } = flex;

    const getTokensFromHtml = () => {
        const encodedTokens = document.getElementById(tokensElementId).innerHTML;
        const tokens = safeJSONParse(lzDecompress(encodedTokens));

        return new TokensModel(
            tokens.token_type,
            tokens.access_token,
            tokens.refresh_token
        );
    };

    const makeStateString = (dataToBeInState) => {
        return JSON.stringify(dataToBeInState);
    };

    const restoreStateFromUrl = () => {
        const stateJSONString = flex.getUrlParam('state') || '{}';

        return JSON.parse(stateJSONString);
    };

    return {
        getTokensFromHtml,
        makeStateString,
        restoreStateFromUrl
    }
};